import React from 'react';
import PokerGameSessionHistory from '../../games/poker/PokerGameSessionHistory';

const AgentPokerSessionHistory = ({ playerID }) => {
    return <PokerGameSessionHistory AgentPlayer={true} playerID={playerID} />
};

export default AgentPokerSessionHistory;